// Contact details — update these when ready (leave empty string to show "coming soon")
export const CONTACT = {
  email: "jo@biffa.net",
  phone: "07817 742299",
};

export const NAV_LINKS = [
  { label: "The Stay", href: "#story" },
  { label: "The Spaces", href: "#suite" },
  { label: "Breakfast", href: "#breakfast" },
  { label: "Wiltshire", href: "#location" },
  { label: "The Host", href: "#host" },
  { label: "Enquire", href: "#enquire" },
];

export const FEATURES = [
  "Private bedroom with a king-size bed",
  "Exclusive use of a well-equipped gym",
  "Private sauna",
  "Modern en-suite shower room",
  "Kitchenette with premium coffee machine & refreshments",
  "Ninja oven, air fryer & sandwich toaster",
  "Continental breakfast with quality produce",
  "Luxury towels & complimentary toiletries",
  "Fast Wi-Fi",
  "Dedicated workspace",
  "Self check-in for complete flexibility",
  "Free parking nearby",
];

export const DESTINATIONS = [
  { name: "Stonehenge", note: "Ancient world wonder" },
  { name: "Avebury Stone Circle", note: "Neolithic henge" },
  { name: "Marlborough", note: "Historic market town" },
  { name: "Devizes & Caen Hill Locks", note: "Canal engineering marvel" },
  { name: "Lacock", note: "Storybook film village" },
  { name: "Castle Combe", note: "England's prettiest village" },
  { name: "Salisbury", note: "Cathedral city" },
  { name: "The Pewsey Vale", note: "Rolling downland" },
  { name: "The Ridgeway", note: "Britain's oldest road" },
  { name: "Countryside walks & cycling", note: "Miles of routes" },
];

export const REVIEWS = [
  {
    quote:
      "We've never stayed anywhere quite like it. The attention to detail is extraordinary — from the bedding to the little extras you don't expect.",
    author: "A recent guest",
    context: "Verified stay",
  },
  {
    quote:
      "Immaculately clean, wonderfully private and full of character. The sauna after a day exploring Wiltshire was pure bliss.",
    author: "A recent guest",
    context: "Verified stay",
  },
  {
    quote:
      "Jo thinks of everything. We arrived as guests and genuinely left feeling like friends. Already planning our return.",
    author: "A recent guest",
    context: "Verified stay",
  },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "A stay unlike any other",
    body: "The Old Pub isn't a boutique hotel, a traditional bed and breakfast or a standard holiday let. It's something wonderfully different — originally part of the historic Wiltshire Yeoman public house, sympathetically reimagined into a luxurious retreat while retaining its unique character.",
  },
  {
    no: "02",
    title: "Obsessed with the little details",
    body: "Having been fortunate enough to stay in some of the world's most exceptional hotels, I've always paid attention to the little details that make a stay memorable. From luxurious bedding and towels to quality coffee and thoughtful breakfast provisions — everything has been carefully chosen with comfort in mind.",
  },
  {
    no: "03",
    title: "Complete privacy, complete independence",
    body: "Although attached to our family home, the cellar is entirely self-contained with its own private entrance, allowing guests complete independence throughout their stay. Quirky, spacious and full of personality — something that simply can't be replicated.",
  },
];
